<template>
  <div class="scoreEvaluation">
    <div v-if="ifList">
      <!-- <div class="tabs">
        <div class="tabs-item" :class="search == 0 ? 'on' : ''" @click="searchClick(0)">
          全部答疑
        </div>
        <div class="tabs-item" :class="search == 1 ? 'on' : ''" @click="searchClick(1)">
          我的提问
        </div>
        <div class="tabs-item" :class="search == 2 ? 'on' : ''" @click="searchClick(2)">
          我的提问
        </div>
      </div> -->
      <div class="coupon-content">
        <!-- <div class="coupon-title">答疑提问</div> -->

        <el-input v-model="formData.content" type="textarea" :rows="4" maxlength="200" show-word-limit
          placeholder="请输入内容..." />
        <div class="flex uploadBpx">
          <div class="w-b-100 flex-end">
            <el-upload ref="upload" :action="imgAction()" :headers="DomainAuthorization" name="upload" :limit="3"
              list-type="picture-card" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess"
              :on-remove="handleRemove">
              <i class="el-icon-plus" />
            </el-upload>
            <div class="tips">
              <span class="num">{{
                formData.imgList ? formData.imgList.length : 0
              }}</span>/3 点击上传图片（最多可上传3张，每张小于2M）
            </div>
          </div>
          <div class="keep-learn keep-check shrink0" @click.stop="send()">
            确认提交
          </div>
        </div>
      </div>
      <div class="soreList">
        <div v-for="(item, index) in list" :key="index" class="sore-item">
          <img class="userImg" :src="item.headPortrait" alt="">
           <!-- @click="open(item)" -->
          <div class="sore-content">
            <div class="userName">{{ item.nickName }}</div>
            <div class="addTime">{{ item.startTime }}</div>
            <div class="content">{{ item.content }}</div>
            <div class="flex-c m-t-24">
              <img v-for="(img, imgIndex) in item.pictureList" :key="imgIndex" class="reply-img m-r-8" :src="img"
                mode="scaleToFill" @click="ViewImage(img)">
            </div>
            <div v-if="item.answerBasicVos && item.answerBasicVos.length > 0" class="answerBasicVos">
              <div v-for="(reply, replyIndex) in item.answerBasicVos" :key="replyIndex" class="reply-item">
                <div v-if="item.isOpen || replyIndex < 3">
                  <div class="dis_flex">
                    <span :class="reply.replyUserId == userInfo.userId || reply.status == 2
                      ? 'color-FF5D51-i '
                      : ''
                      " class="name-span">{{
                        reply.replyUserId == userInfo.userId
                          ? "我"
                      : reply.username
                      }}</span>
                    :
                    <span class="name-content m-l-8">{{
                      reply.content
                    }}</span>
                    <img v-if="reply.isOptimum == 1" class="optimal"
                      src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/optimal.png">
                  </div>
                  <div v-if="reply.pictureList && reply.pictureList.length > 0" class="flex-c m-t-24">
                    <img v-for="(img, imgIndex) in reply.pictureList" :key="imgIndex" class="reply-img m-r-8" :src="img"
                      mode="scaleToFill" @click="ViewImage(img)">
                  </div>
                </div>
              </div>
              <div v-if="item.answerBasicVos.length > 3" class="reply-more m-t-24 color-FF5D51-i"
                :class="item.isOpen ? 'open' : ''" @click.stop="repalyOpen(item)">
                {{
                  !item.isOpen ? `查看全部${item.answerBasicVos.length}条` : "收起"
                }}
                <i class="iconfont icon-gengduo" />
              </div>
            </div>
            <!-- <div class="replyClick">
              <i class="iconfont icon-Frame" /><el-button type="text" class="info">回复</el-button>
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="!list || list.length == 0" class="nothing">
        <div class="nothing-span">暂无答疑哦~</div>
      </div>
      <el-pagination class="pagination" :total="total" :current-page="pageNum" :page-sizes="[5, 10, 15, 40]"
        :page-size="pageSize" :pager-count="5" background layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    </div>
    <el-dialog custom-class="myDialog" :visible.sync="ifCoupon" width="700px" @close="clode">
      <div class="coupon-content">
        <!-- <div class="coupon-title">
          {{ formData.nickName ? "回复：" + formData.nickName : "答疑" }}
        </div> -->

        <el-input v-model="dialog.content" type="textarea" :rows="4" maxlength="200" show-word-limit
          placeholder="请输入内容..." />
        <div class="uploadBpx">
          <div class="w-b-100 flex-end">
            <el-upload ref="uploadReply" :action="imgAction()" name="upload" :headers="DomainAuthorization" :limit="3"
              list-type="picture-card" :on-success="dialogSuccess" :on-remove="dialogRemove">
              <i class="el-icon-plus" />
            </el-upload>
            <div class="tips">
              <span class="num">{{
                dialog.imgList ? dialog.imgList.length : 0
              }}</span>/3 点击上传图片（最多可上传3张，每张小于2M）
            </div>
          </div>
        </div>
        <div class="flex-e">
          <div class="keep-learn keep-check" @click.stop="send()">确认提交</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import { getInfo, getDomainToken } from '@/api/cookies'
// import { Evaluation } from '@/api/scoreEvaluation'
// const evaluation = new Evaluation()
import { HomeClient } from "@/api/home";
import { debounce } from "@/utils/public"
const homeClient = new HomeClient();
export default {
  props: {
    type: {
      type: Number // /type	 1课程  2试卷
    },
    IsPurchase: {
      type: Boolean
    },
    ifList: {
      default: true,
      type: Boolean
    },
    courseId: {
      // 产品id（课程  试卷）
      type: String | Number
    },
    chapterId: {
      // id（课程章节   试卷试题）
      type: String | Number
    },
    status: {
      // 1直播 2录播  3 音频 4试卷
      type: String | Number
    },
    detail: {
      type: Object,
      default: () => { }
    },
    semesterId: {
      type: String | Number
    }
  },
  data() {
    return {
      pageSize: 5,
      pageNum: 1,
      total: 0,
      list: [],
      userInfo: null,
      /* 提交答疑 */
      ifCoupon: false,
      thisList: null,
      search: 0,
      DomainAuthorization: {
        DomainAuthorization: getDomainToken()
      },
      formData: {
        questionsId: null,
        nickName: null,
        content: '',
        imgList: []
      },
      canClick: true,
      dialog: {
        questionsId: null,
        nickName: null,
        content: '',
        imgList: []
      }
    }
  },
  async created() {
    this.userInfo = getInfo()
    this.ifCoupon = !this.ifList
    console.log(this.detail, 'detail');

    setTimeout(() => {
      this.getList()
    }, 1000)
    // await
  },
  methods: {
    searchClick(val) {
      if (val) {
        const userInfo = getInfo()
        if (!userInfo) {
          Vue.prototype.goLoginView(false)
        }
      }
      this.search = val
      this.pageSize = 5
      this.pageNum = 1
      this.list = []
      this.getList()
    },
    getList() {
      homeClient.getQuestionListByCourse(this.pageNum, this.pageSize, this.courseId, this.chapterId, this.search).then((res) => {
        this.list = res.data.rows;
        this.total = res.data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    beforeAvatarUpload(file) {
      const allowImgType = ['image/jpeg', 'image/png', 'image/gif']
      if (!allowImgType.includes(file.type)) {
        this.$message.error('上传文件类型不符,仅支持jpg/png/gif格式图片')
        return false
      }
    },

    /* =======================发送答疑======================== */
    // 图片上传
    handleAvatarSuccess(res, file, fileList) {
   
        if (!this.formData.imgList) {
          this.formData.imgList = []
        }
        // const data = { url: res.path, path: '' }
        this.formData.imgList.push(res.data)
     
    },
    dialogSuccess(res, file, fileList) {
      console.log('上传成功')
   
        if (!this.dialog.imgList) {
          this.dialog.imgList = []
        }
        // const data = { url: res.data, path: '' }
        this.dialog.imgList.push(res.data)
      
    },
    /* 移除2 */
    handleRemove(file, fileList) {
      console.log(file,'ffff')
      this.formData.imgList = this.formData.imgList.filter((item) => {
        return item != file.response.data
      })
      this.$forceUpdate()
    },
    dialogRemove(file, fileList) {
      console.log('删除成功')
      this.dialog.imgList = this.dialog.imgList.filter((item) => {
        return item != file.response.data
      })
      this.$forceUpdate()
    },
    /* 提交 */
    send: debounce(function() {
      if (!this.canClick) {
        return
      }
      this.canClick = false
      const userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }
      if (!this.formData.content) {
        this.$message({
          showClose: true,
          message: '提交内容不能为空!',
          type: 'warning'
        })
        this.canClick = true
        return
      }
      homeClient
        .addAnswerQuestion(
          {
            belongCourseTitleId: this.detail.belongCourseTitle,
            course: this.detail.courseId,
            videoType: this.type,
            section: this.detail.chapterId,
            type: 0,
            content: this.formData.content,
            source: 2,
            isOffline: 0,
            pictureList: this.formData.imgList
          }
        )
        .then((res) => {
          if (res.code == 0) {
            this.ifCoupon = false
            this.$emit('close')
            this.getList()
            this.formData = {
              questionsId: null,
              nickName: null,
              content: '',
              imgList: []
            }
            this.$refs.uploadReply.clearFiles()
          }
        })

      this.canClick = true
    }, 300),
    /* 打开回复弹窗 */
    open(item) {
      if (item.isClose == 1) {
        this.$notify({
          title: '错误',
          message: '此内容不可回复',
          type: 'error',
          duration: 2000
        })
        return
      }
      if (item) {
        this.formData.questionsId = item.id
        this.formData.nickName = item.nickName
      }
      this.dialog.content = ''
      this.dialog.imgList = []
      this.ifCoupon = true
    },
    /* 打开回复 */
    repalyOpen(reply) {
      if (reply.isOpen) {
        reply.isOpen = false
      } else {
        reply['isOpen'] = true
      }
      this.$forceUpdate()
    },
    clode() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
/* 标签 */
.tabs {
  display: flex;
  padding: 32px 32px 16px;

  .tabs-item {
    width: 112px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #666666;
    line-height: 38px;
    text-align: center;
    margin-right: 20px;
    border: 1px solid #eeeeee;
    cursor: pointer;
  }

  .on {
    background: #ffedeb;
    border: 1px solid #ff5d51;
    color: #ff5d51;
  }
}

/* 内容 */
.soreList {
  padding: 0px 32px;
  width: 100%;

  .sore-item {
    width: 100%;
    display: flex;
    padding: 32px 0px;
    border-bottom: 1px solid #f7f7f7;
    position: relative;

    .optimal {
      width: 65px;
      height: 22px;
      margin-left: 8px;
      /*   position: absolute;
      top: 0px; */
    }

    .userImg {
      width: 48px;
      height: 48px;

      border-radius: 50%;
      margin-right: 16px;
      flex-shrink: 0;
    }

    .sore-content {
      width: 100%;

      .userName {
        height: 16px;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        margin-top: 5px;
      }

      .addTime {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        margin-top: 8px;
      }

      .content {
        font-size: 16px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #666666;
        line-height: 16px;
        margin-top: 21px;
      }

      /* 回复列表 */
      .answerBasicVos {
        width: 100%;
        background: #f5f7f9;
        border-radius: 8px;
        padding: 20px;
        margin-top: 20px;
        transition: height 1s;

        // height: 100%;
        .reply-item {
          margin-top: 12px;
          font-size: 16px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
          position: relative;

          .name-span {
            color: #373a42;
            flex-shrink: 0;
          }

          .name-tips {
            margin: 0px 8px;
          }

          .name-type {
            padding: 0px 4px;
            height: 28px;
            background: #ff5d51;
            border-radius: 4px 4px 4px 4px;

            text-align: center;
            font-size: 20px;
            font-family: PingFang SC-Regular;
            font-weight: 400;
            color: #ffffff;
            line-height: 28px;
            margin: 0px 8px;
          }
        }

        .reply-more {
          font-size: 14px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #ff5e51;
          line-height: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;

          .iconfont {
            color: #ff5d51;
            font-size: 14px;
            line-height: 14px;
            margin: 0px 8px;
            transition: transform 0.4s;
            transform: rotate(0deg);
          }
        }

        .open {
          .iconfont {
            transform: rotate(-90deg);
            transition: transform 0.4s;
            display: inline-block;
          }
        }
      }

      /* 回复 */
      .replyClick {
        height: 12px;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 12px;
        margin-top: 16px;

        .iconfont {
          font-size: 12px;
          color: #999999;
          margin-right: 8px;
        }
      }
    }
  }
}

/* 提价 */
.scoreEvaluation {
  min-height: 300px;
  background: #fff;
}

.answer-img {
  position: fixed;
  bottom: 200px;
  right: 16px;

  img {
    width: 96px;
    height: 96px;
  }
}

.reply-img {
  width: 120px !important;
  height: 120px !important;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
}

.coupon-content {
  padding: 20px 32px;

  .coupon-title {
    margin: 0px 0px 26px;
    display: flex;
    align-items: center;

    .rate {
      margin-left: 12px;

      /deep/ .el-rate {
        height: 100%;

        .el-rate__icon {
          font-size: 22px;
        }
      }
    }
  }

  .keep-learn {
    height: 40px;
    line-height: 38px;
    padding: 0px 28px;
    margin: 24px 0px 18px;
    float: right;
  }
}

.uploadBpx {
  margin-top: 12px;

  /deep/ .el-upload-list__item {
    width: 60px;
    height: 60px;
  }

  /deep/ .el-upload--picture-card {
    width: 60px;
    height: 60px;
    line-height: 58px;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #dddddd;
  }

  .tips {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    margin-left: 8px;

    .num {
      color: #ff5e51;
    }
  }
}

.keep-learn {
  height: 40px;
  line-height: 38px;
  padding: 0px 28px;
  margin: 24px 0px 18px;
  float: right;
}

.pagination {
  padding-bottom: 20px;
}

/deep/.el-textarea {
  border: 1px solid #fe1313;

  .el-textarea__inner {
    background: #f5f7f9;
    border-radius: 8px 8px 8px 8px;
    border: none;
  }
}
</style>
